import { isEmpty, isNull } from 'lodash';
import React from 'react';
import { getParagraphOne } from '../../../common/helpers/ui/dataFilter';
import { handleImageUrl } from '../../../common/helpers/sharpie/imageUrlHelper';
import { contentPageTitle } from '../../../common/helpers/ui/pageTitleMetaDescription';

interface Author {
  name: string;
}

interface SEO {
  metadesc?: string;
}

interface FeaturedImage {
  url: string;
}
interface Post {
  seo?: SEO;
  title: string;
  postCategory: string;
  modified: string;
  date: string;
  featuredImage?: FeaturedImage;
  author?: Author;
  content?: string;
}
interface ContentSchemaProps {
  post?: Post;
}
const defaultPost: Post = {
  seo: {},
  title: '',
  postCategory: '',
  modified: '',
  date: '',
  featuredImage: { url: '' },
  author: { name: '' },
  content: '',
};
const SEO_IMAGE_WIDTH = 1200;
const SEO_IMAGE_HEIGHT = 630;

const ContentSchema: React.FC<ContentSchemaProps> = () => {
  const {
    seo,
    title,
    postCategory,
    modified,
    date,
    featuredImage,
    author,
    content,
  } = defaultPost;

  const seoTitle = contentPageTitle(title, postCategory);
  const description = !isEmpty(seo.metadesc)
    ? seo.metadesc
    : getParagraphOne(content);
  const imageUrl = handleImageUrl(
    !isNull(featuredImage) ? featuredImage.url : '',
    SEO_IMAGE_WIDTH,
    SEO_IMAGE_HEIGHT,
  );

  const logoUrl =
    'https://cdn-assets.prod.thinkofliving.com/_next/static/images/tol-logo-text-7f98a1ca4e741f5e61ef43ea8e9d5144.jpg';
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    about: {
      '@type': 'Thing',
      name: seoTitle,
    },
    headline: seoTitle,
    description: description,
    datePublished: date,
    dateModified: modified,
    author: {
      '@type': 'Person',
      name: author.name,
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': 'https://thinkofliving.com/',
    },
    image: {
      '@type': 'ImageObject',
      url: imageUrl,
      height: 630,
      width: 1206,
      publisher: {
        '@type': 'Organization',
        name: ' thinkofliving ',
        logo: {
          '@type': 'ImageObject',
          url: logoUrl,
          width: 600,
          height: 60,
        },
      },
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default ContentSchema;
